import { DOCUMENT, LocationStrategy } from '@angular/common'
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  Output,
} from '@angular/core'
import {
  CommentLink,
  NOTIFICATION_LINK_EVENT,
  NOTIFICATIONS_API_BASE,
  NOTIFICATIONS_TAG,
  readCommentLink,
  whenSidenavReady,
} from '../external-components/notification-ui'

@Component({
  selector: 'hs-notifications-bell',
  template: '',
  styleUrls: ['./notifications-bell.component.scss'],
})
export class NotificationsBellComponent implements AfterViewInit, OnDestroy {
  @Input() commentLinksEnabled = false
  @Output() readonly commentLink = new EventEmitter<CommentLink>()

  private bell?: HTMLElement
  private isDestroyed = false

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly host: ElementRef<HTMLElement>,
    private readonly locationStrategy: LocationStrategy,
  ) {}

  ngAfterViewInit(): void {
    void this.mountBell()
  }

  ngOnDestroy(): void {
    this.isDestroyed = true
    this.bell?.removeEventListener(
      NOTIFICATION_LINK_EVENT,
      this.onNotificationLink,
    )
    this.bell?.remove()
    this.bell = undefined
  }

  private readonly onNotificationLink = (event: Event): void => {
    if (!this.commentLinksEnabled) return
    const link = readCommentLink(
      event,
      this.document.location.origin,
      this.locationStrategy.getBaseHref(),
    )
    if (!link) return
    event.preventDefault()
    this.commentLink.emit(link)
  }

  private async mountBell(): Promise<void> {
    const window = this.document.defaultView
    if (!window) return
    await whenSidenavReady(window)
    if (this.isDestroyed) return
    // whenDefined's promise is not zone-aware, so awaiting it when already
    // defined defers the mount past Angular's microtask drain.
    if (!customElements.get(NOTIFICATIONS_TAG)) {
      await customElements.whenDefined(NOTIFICATIONS_TAG)
      if (this.isDestroyed) return
    }

    const bell = this.document.createElement(NOTIFICATIONS_TAG)
    bell.setAttribute('api-base', NOTIFICATIONS_API_BASE)
    bell.addEventListener(NOTIFICATION_LINK_EVENT, this.onNotificationLink)
    this.host.nativeElement.appendChild(bell)
    this.bell = bell
  }
}
